<template>
    <div id="comFinDetailBox">
        <h2></h2>     
        <div class="listItem">
            <el-table ref="multipleTable" :data="profileList" :show-header="false" :cell-style="{padding: '3px', height: '35px'}" :header-cell-style="{ background: 'transparent'}" style="width: 100%;overflow-y:auto;"  empty-text="暫無數據">
                <el-table-column label="標題" prop="title" min-width="35%"> </el-table-column>
                <el-table-column label="內容" prop="value" min-width="65%" ></el-table-column>
            </el-table>
        </div>
        <div class="buttonBox">            
            <el-button type="danger"  @click="closeWin()" ><font-awesome-icon icon="times"  style="margin-right:5px;" />關閉</el-button>
        </div>        
    </div>
</template>

<script>
import Pagination from '../components/Pagination.vue';

export default {
    components: {Pagination},
    data() {
        return {
            profileList:[],
            qry : {
                "DataDt": this.$route.query.dataDt,
                "SearchContent" : [this.$route.query.comName],
                "Page_Size":10,
                "Page_Num":1
            }
        }        
    },
    methods: {
        getList() {
            this.$store.dispatch("loadingHandler", true);
            this.$api.apimgrs.searchMopsFincialInfo(this.qry).then(res => {
                console.log("data",res.data);
                if( res.data.length > 0 ) {
                    var ret = res.data[0];
                    this.profileList.push({title:"市場類別", value: ret.ComType });
                    this.profileList.push({title:"產業類別", value: ret.IndusType });
                    this.profileList.push({title:"證券代號", value: ret.StockCode });
                    this.profileList.push({title:"公司名稱", value: ret.ComName });
                    this.profileList.push({title:"每股淨值(元)或累積盈虧(仟元)-年度", value: ret.PerStockYear });
                    this.profileList.push({title:"每股淨值(元)或累積盈虧(仟元)-淨值", value: ret.PerStockValue });
                    this.profileList.push({title:"指標1-現行股票交易方式", value: ret.Ind01 });
                    this.profileList.push({title:"指標2-最近3年度稅後損益(仟元)-年度", value: ret.Ind0201Year });
                    this.profileList.push({title:"指標2-最近3年度稅後損益(仟元)", value: ret.Ind0201Value });
                    this.profileList.push({title:"指標2-最近2年度稅後損益(仟元)-年度", value: ret.Ind0202Year });
                    this.profileList.push({title:"指標2-最近2年度稅後損益(仟元)", value: ret.Ind0202Value });
                    this.profileList.push({title:"指標2-最近1年度稅後損益(仟元)-年度", value: ret.Ind0203Year });
                    this.profileList.push({title:"指標2-最近1年度稅後損益(仟元)", value: ret.Ind0203Value });
                    this.profileList.push({title:"指標3-負債比率(%)", value: ret.Ind0301 });
                    this.profileList.push({title:"指標3-流動比率", value: ret.Ind0302 });
                    this.profileList.push({title:"指標4-最近2年度營業活動淨現金流量(仟元)-年度", value: ret.Ind0401Year });
                    this.profileList.push({title:"指標4-最近2年度營業活動淨現金流量(仟元)", value: ret.Ind0401Value });
                    this.profileList.push({title:"指標4-最近1年度營業活動淨現金流量(仟元)-年度", value: ret.Ind0402Year });
                    this.profileList.push({title:"指標4-最近1年度營業活動淨現金流量(仟元)", value: ret.Ind0402Value });
                    this.profileList.push({title:"指標4-最近期營業活動淨現金流量(仟元)-年度", value: ret.Ind0403Year });
                    this.profileList.push({title:"指標4-最近期營業活動淨現金流量(仟元)", value: ret.Ind0403Value });
                    this.profileList.push({title:"指標5-資金貸與餘額占淨值比率(%)", value: ret.Ind05 });
                    this.profileList.push({title:"指標6-背書保證餘額占淨值比率(%)", value: ret.Ind06 });
                    this.profileList.push({title:"指標7-其他", value: ret.Ind07 });
                    this.profileList.push({title:"符合指標數量", value: ret.MatchIndQty });        
                }
                    
                else
                    this.profileList = [];
                var ret = res.data[0];                
            });
            this.$store.dispatch("loadingHandler", false);
        },
        closeWin() {
            window.close();
        },   
        millionStr(intPart) {
            let newPart = Math.trunc(intPart);
            return newPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');            
        },                  
    },
    async mounted() {
        this.$store.dispatch("loadingHandler", true);
        console.log("ComName",this.qry);
        this.getList();
        this.$store.dispatch("loadingHandler", false);
    }    
}
</script>

<style lang="scss" scoped>
#comFinDetailBox {
  background: linear-gradient(-135deg, #FFF 20%, #fff 50%, transparent 50%)
    center center / 100% 100%;
  min-height: 100vh;
  padding: 0px 0%;

  .listItem   {
    padding: 0 5%;
  }

  .buttonBox {
    padding: 0 5%;
    display: flex;
    justify-content: center;

  }
}
</style>